import axios from 'axios';

export default async function deleteGreetsAction(greets: string[]) {
  return await axios('/api/v2/greets', {
    method: 'DELETE',
    data: {
      greets,
    },
  }).then((res) => res.data);
}
